import React from 'react'
import { connect } from 'react-redux'
import { Card, Col, Row, PageHeader } from 'antd';

export const School = (props) => {
    let {
        name,
        abbrv,
        links,
        staffname,
        color,
        state,
        country,
        email,
        phone1,
        phone2,
        address,
        officename
      } = props.data || ''
      
    return (
        <>
        <PageHeader
                title="School"
                className="site-page-header no-print"
                subTitle="My School"
                extra={[]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/bank.png' }}     
            ></PageHeader>
        <Card>
        <Card type="inner" style={{paddingBlock:'2px'}} >
            <Row span={24} className="d-flex justify-content-center" >
                <Col 
                    span={24}     
                    className="d-flex justify-content-center"
                    style ={{marginBlock:'auto', width:'100%'}}>
                  <img 
                  height='100px'
                  alt="school logo" 
                  src={process.env.REACT_APP_SERVER_URL+ links} 
                  onError={(e)=>{
                    e.target.onerror=null; 
                    e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                  } }
                  />
                </Col>
            </Row>
            <hr style={{color:color}}/>
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-university fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page" ><strong style={{fontFamily:'Quicksand'}}>{name}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-thumb-tack fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page" ><strong style={{fontFamily:'Quicksand'}}>{abbrv}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-map-marker fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page"><strong style={{fontFamily:'Quicksand'}}>{address}{" "}{state}{" "}{country}{" "}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-envelope fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page"><strong style={{fontFamily:'Quicksand'}}>{email}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-phone fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page"><strong style={{fontFamily:'Quicksand'}}>{phone1}{" "}{phone2}</strong></Col>
            </Row>
            <hr/>
            
            <Row>
                <Col xs={24} sm={3} span={4}><i style={{color:color}} className="fa fa-user fa-2x school_page_icons"></i></Col>
                <Col xs={24} sm={21} span={20} className="school_page"><strong style={{fontFamily:'Quicksand'}}>{staffname}{" "}{officename}</strong></Col>
            </Row>
            <hr/>
        </Card>
    </Card>
    </>
    )
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(School)
